import React from "react";

const CenterAlign = ({ width = 14, height = 14, selected }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 17"
      fill={selected ? "#0072C6" : "white"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 8V9H0V8H14Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 0V3L5 3V0L9 0Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 4V7H5V4H9Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 10V13H5V10H9Z"
        fill={selected ? "white" : "black"}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 14V17H5V14H9Z"
        fill={selected ? "white" : "black"}
      />
    </svg>
  );
};

export default CenterAlign;
